import React from 'react';
import { Modal } from '@components/common/modal';
import CloseModalButton from '@components/common/modal/CloseModalButton';

export type CustomModalPropsType = {
  children: React.ReactElement;
  closeButtonTheme?: 'dark';
  needCloseButton?: boolean;
  onClose: Function;
  onClickClose?: Function;
};

const CustomModal = ({
  children,
  needCloseButton,
  closeButtonTheme,
  onClose,
  onClickClose,
}: CustomModalPropsType) => {
  return (
    <Modal onClickClose={onClickClose} onClose={onClose}>
      {React.cloneElement(children, { onClickClose, onClose })}
      {needCloseButton && (
        <div className="absolute top-[26px] right-[26px]">
          <CloseModalButton
            dark={closeButtonTheme === 'dark'}
            onClickClose={onClickClose}
            onClose={onClose}
          />
        </div>
      )}
    </Modal>
  );
};

export default CustomModal;
